import { mapGetters } from 'vuex';

import Sticky from '../sticky/sticky.vue';

import WindowWidthMixin from '../../../mixins/window.width.mixin';
import DeepChangerMixin from '../../../mixins/deep.changer.mixin';

import KeyboardHelper from '../../../helpers/keyboard.helper';

import { classList, scrollTop } from '../utils';
import delay from 'lodash/delay';
import defaults from 'lodash/defaults';
import result from 'lodash/result';
import isBoolean from 'lodash/isBoolean';
import each from 'lodash/each';
import noop from 'lodash/noop';

import { POPUP_CLOSED, POPUP_OPENED } from '../../../store/mutation-types';

const DEFAULT_OPTIONS = Object.freeze({
   showClose: true,
   showConfirm: true,
   showCancel: true,
   showFooter: true,
   showHeader: true,

   message: '',

   headerText: '',

   confirmText: 'Ok',
   cancelText: 'Cancel',

   closeOnBackdrop: true,
   transparentBackdrop: false,

   canConfirmChecker: true,
   canCloseChecker: true
});

const ESC_CODE = 27;
const ENTER_CODE = 13;
const ALL_KEYS = 0;

export default {
   name: 'Dialog',
   mixins: [ WindowWidthMixin, DeepChangerMixin ],
   components: { Sticky },
   props: {
      options: {
         type: Object,
         default() {
            return {};
         }
      }
   },
   data() {
      return {
         opts: defaults(this.options, DEFAULT_OPTIONS),
         inprocess: false,
         isActive: false,
         canBeClosed: false
      };
   },
   watch: {
      getRoutePath: 'close'
   },
   computed: {
      top() {
         return `${scrollTop()}px`;
      },
      isFullSize() {
         return this.isMobile;
      },
      ...mapGetters(['isMobile', 'getRoutePath'])
   },
   methods: {
      handleMouseDown() {
         const { target } = event;
         if (!this.$refs.container || this.$refs.container.contains(target)) {
            return;
         }
         this.canBeClosed = true;
      },
      onTouchMove(event) {
         if (event.target === this.$refs.backdrop) {
            event.stopPropagation();
            event.preventDefault();
            return false;
         }
         return true;
      },
      onBackdropClick(event) {
         if (!result(this, 'opts.closeOnBackdrop')) {
            return;
         }
         const { target } = event;
         if (!this.$refs.container || this.$refs.container.contains(target)) {
            return;
         }
         if (!this.canBeClosed) {
            return;
         }
         const track = this.$refs.backdrop.$refs.track;
         if (track === target || track.contains(target)) {
            return;
         }

         this.close();
      },
      confirm() {
         const canConfirm = result(this, 'opts.canConfirmChecker');
         if ( !isBoolean(canConfirm) ) {
            this.inprocess = true;
            canConfirm.then(() => {
               this.inprocess = false;
               this.action('confirm');
            }, () => this.inprocess = false);
         } else if (canConfirm) {
            this.action('confirm');
         }
      },
      close() {
         if (result(this, 'opts.canCloseChecker')) {
            this.action('close');
         }
      },
      action(type) {
         if ( this.inprocess ) {
            return;
         }

         this.isActive = false;

         delay(() => {
            this.$emit(type);
            this.$destroy(true);
         });
      },
      focus() {
         this.$refs.container.focus();
      }
   },
   mounted() {
      this.storeWindowWidth();
      classList(document.body).add('modal-on');
      delay(() => this.isActive = true );
      const options = { stop: true, unshift: true };

      this._listeners = [
         KeyboardHelper.keydown(noop, ALL_KEYS, options),
         KeyboardHelper.keydown(this.confirm, ENTER_CODE, options),
         KeyboardHelper.keydown(this.close, ESC_CODE, { ...options, ignoreInput: false })
      ];
      document.activeElement.blur();
      this.$store.commit(POPUP_OPENED);
   },
   destroyed() {
      this.restoreWindowWidth();
      classList(document.body).remove('modal-on');
      each(this._listeners, off => off());
      this._listeners.length = 0;
      this.$store.commit(POPUP_CLOSED);
   }
};
